module.exports = __webpack_public_path__ + "static/ResumePaulo-6a714cb44d27cc636ca76e45fd72e640.pdf";